import { PartialRootState } from './types';

const initialState: PartialRootState = {
  list: {
    isLoading: false,
    error: '',
    data: [],
  },
};

export default initialState;
